import {openDeleteDialog, showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {head, isNil} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {useDeleteFastTrackIssueMutation} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';
import {
  DmsDataGrid,
  WAREHOUSE_GRID_CODES,
  catchUnhandledDataGridActions,
  handleApiError,
  logError,
  refreshDmsDatagrid,
} from '@dms/shared';
import {FullscreenDataGridWrapper} from '@dms/warehouse/shared-components';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function FastTrackIssues() {
  const navigate = useNavigate();

  const [deleteFastTrackIssue] = useDeleteFastTrackIssueMutation();

  const actionCallback: ActionCallback = async ({actionKey, rowId, sourceSearchParams}) => {
    await match(actionKey)
      .with('redirectDetail', () => {
        const selectedRowId = isArray(rowId) ? head(rowId) : rowId;

        if (isNil(selectedRowId)) {
          return logError('rowId is not defined');
        }

        navigate(
          composePath(warehouseRoutes.fastTrackIssuesDetailOverview, {
            queryParams: sourceSearchParams,
            params: {id: selectedRowId},
            isSearchParamsPreserved: false,
          })
        );
      })
      .with('delete', async () => {
        const id = isArray(rowId) ? rowId : [rowId];

        await openDeleteDialog({
          onConfirm: () =>
            deleteFastTrackIssue({
              fastTrackIds: id,
            })
              .unwrap()
              .then(() =>
                showNotification.success(i18n.t('general.notifications.successfullyDeleted'))
              )
              .then(() =>
                refreshDmsDatagrid(WAREHOUSE_GRID_CODES.fastTrackIssues, {deselectAll: true})
              )
              .catch(handleApiError),
        });
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };
  return (
    <FullscreenDataGridWrapper hideCardWrapper>
      <DmsDataGrid
        gridCode={WAREHOUSE_GRID_CODES.fastTrackIssues}
        actionCallback={actionCallback}
        data-testid={WAREHOUSE_GRID_CODES.fastTrackIssues}
      />
    </FullscreenDataGridWrapper>
  );
}
